import React from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Moment from 'moment';

import '../ageField/AgeField.css';

import ReactDOM from 'react-dom';
import I18n from 'i18n-react';

const DATE_FORMAT = 'DD/MM/YYYY';
const MIN_DATE = '01/01/1900';

const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  lastFlightDate: PropTypes.string.isRequired,
  changeValue: PropTypes.func.isRequired,
  value: PropTypes.string
};

const defaultProps = {
  label: '',
  required: false,
  errorMessage: '',
  placeholder: '',
  value: null
};

class DateField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValidState: true,
      value: props.value ? props.value : '',
      errorMessage: ''
    };
  }

  componentWillReceiveProps(props) {
    if (props.value !== null) {
      this.setState({
        value: props.value
      });
    }
  }

  renderLabel() {
    let label = '';

    if (this.props.label) {
      label = (
        <Row className="Field__label">
          <Col id={`${this.props.id}_ageFieldLabel`} xs={12}>
            <span className={this.state.isValidState ? 'Field__validField' : 'Field__invalidField'}>
              {I18n.translate(this.props.label)}
            </span>
            {this.props.required ? (
              <span id="requiredIconId" className="Field__required">
                {' '}
                •
              </span>
            ) : (
              ''
            )}
          </Col>
        </Row>
      );
    }

    return label;
  }

  renderField() {
    return (
      <Row>
        <Col xs={12}>
          <input
            id={`${this.props.id}_ageFieldId`}
            onBlur={event => this.validateField(event.target.value)}
            onChange={event => this.removeInvalidCharacters(event.target.value)}
            placeholder={I18n.translate(this.props.placeholder)}
            maxLength="10"
            className={`data-hj-whitelist Field__input ${
              this.state.isValidState ? 'Field__validInput' : 'Field__invalidInput'
            }`}
            value={this.state.value}
            ref={c => (this.input = c)}
          />
        </Col>
      </Row>
    );
  }

  renderValidationMessage() {
    let message = <Row id={`${this.props.id}_ageFieldFooter`} className="Field__message" />;

    if (!this.state.isValidState) {
      message = (
        <Row className="Field__message error">
          <Col id={`${this.props.id}_ageFieldFooter`} xs={12}>
            <span className="Field__invalidField">{I18n.translate(this.state.errorMessage)}</span>
          </Col>
        </Row>
      );
    }

    return message;
  }

  validate = () => {
    return this.validateField(this.state.value);
  };

  validateField = value => {
    const dateValue = Moment(value, DATE_FORMAT);

    let errorMessage = '';

    if (this.props.required && !dateValue.isValid()) {
      errorMessage = this.props.errorMessage;
    } else if (value.length === 8) {
      errorMessage = 'components.passengerInfo.birthdate.minplaceholder';
    } else if (dateValue.isBefore(Moment(MIN_DATE, DATE_FORMAT))) {
      errorMessage = 'components.passengerInfo.birthdate.minAgeErrorMessage';
    }

    const isValid = !errorMessage;
    this.setState({
      isValidState: isValid,
      value: dateValue.isValid() ? value : '',
      errorMessage: errorMessage
    });

    this.props.changeValue(dateValue.isValid() ? value : '');
    return isValid;
  };

  removeInvalidCharacters = value => {
    for (var newValue = '', i = 0; i < value.length; i++) {
      if (value.charAt(i).match(/[0-9\\/]/)) {
        newValue += newValue.length === 2 || newValue.length === 5 ? '/' : '';
        newValue += !value.charAt(i).match(/[\\/]/) ? value.substr(i, 1) : '';
      }
    }
    this.setState({
      value: newValue
    });

    // Fix bug cursor Android
    const component = ReactDOM.findDOMNode(this.input);
    setImmediate(() => {
      component.setSelectionRange(component.value.length, component.value.length);
    });
  };

  render() {
    return (
      <div id={this.props.id} className="AgeField Field">
        {this.renderLabel()}
        {this.renderField()}
        {this.renderValidationMessage()}
      </div>
    );
  }
}

DateField.propTypes = propTypes;
DateField.defaultProps = defaultProps;

export default DateField;



// WEBPACK FOOTER //
// ./src/components/passengerInfo/dateField/DateField.jsx